(function () {
  const money = function (cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  };

  function initHeader() {
    const header = document.querySelector('.cst-header');
    if (!header) return;

    const toggle = document.querySelector('.cst-header__toggle');
    if (toggle) {
      toggle.addEventListener('click', function () {
        header.classList.toggle('is-open');
      });
    }

    const updateHeaderState = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 12);
    };

    updateHeaderState();
    window.addEventListener('scroll', updateHeaderState, { passive: true });
  }

  function initQuantity() {
    document.addEventListener('click', function (event) {
      const minus = event.target.closest('[data-qty-minus]');
      const plus = event.target.closest('[data-qty-plus]');
      if (!minus && !plus) return;

      const wrapper = event.target.closest('.cst-quantity');
      const input = wrapper ? wrapper.querySelector('.cst-quantity__input') : null;
      if (!input) return;

      let value = parseInt(input.value || '1', 10);
      if (minus) value = Math.max(1, value - 1);
      if (plus) value += 1;
      input.value = value;
    });
  }

  function setGalleryIndex(gallery, index) {
    const thumbs = gallery.querySelectorAll('[data-cst-thumb]');
    const slides = gallery.querySelectorAll('[data-cst-slide]');
    const total = slides.length;
    if (!total) return;

    let nextIndex = Number(index);
    if (nextIndex < 0) nextIndex = total - 1;
    if (nextIndex >= total) nextIndex = 0;

    thumbs.forEach(function (item) {
      item.classList.toggle('is-active', Number(item.getAttribute('data-cst-thumb')) === nextIndex);
    });

    slides.forEach(function (slide) {
      slide.classList.toggle('is-active', Number(slide.getAttribute('data-cst-slide')) === nextIndex);
    });

    gallery.dataset.cstCurrentIndex = String(nextIndex);
    const counter = gallery.querySelector('[data-cst-gallery-counter]');
    if (counter) counter.textContent = String(nextIndex + 1);
  }

  function initGallery() {
    document.addEventListener('click', function (event) {
      const thumb = event.target.closest('[data-cst-thumb]');
      if (thumb) {
        const gallery = thumb.closest('[data-cst-gallery]');
        if (!gallery) return;
        setGalleryIndex(gallery, thumb.getAttribute('data-cst-thumb'));
        return;
      }

      const prev = event.target.closest('[data-cst-gallery-prev]');
      const next = event.target.closest('[data-cst-gallery-next]');
      if (prev || next) {
        const gallery = event.target.closest('[data-cst-gallery]');
        if (!gallery) return;
        const current = Number(gallery.dataset.cstCurrentIndex || 0);
        setGalleryIndex(gallery, current + (next ? 1 : -1));
      }
    });
  }

  function getGalleryImages(gallery) {
    return Array.from(gallery.querySelectorAll('[data-cst-slide] img')).map(function (img) {
      return {
        src: img.currentSrc || img.src,
        alt: img.alt || ''
      };
    });
  }

  function renderLightbox(gallery, index) {
    const lightbox = gallery.querySelector('[data-cst-lightbox]');
    const stage = gallery.querySelector('[data-cst-lightbox-stage]');
    if (!lightbox || !stage) return;

    const images = getGalleryImages(gallery);
    if (!images.length) return;

    let nextIndex = Number(index);
    if (nextIndex < 0) nextIndex = images.length - 1;
    if (nextIndex >= images.length) nextIndex = 0;

    const image = images[nextIndex];
    stage.innerHTML = `<img src="${image.src}" alt="${image.alt.replace(/"/g, '&quot;')}">`;
    lightbox.dataset.cstLightboxIndex = String(nextIndex);
  }

  function openLightbox(gallery, index) {
    const lightbox = gallery.querySelector('[data-cst-lightbox]');
    if (!lightbox) return;
    renderLightbox(gallery, index);
    lightbox.classList.add('is-open');
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cst-lightbox-open');
  }

  function closeLightbox(lightbox) {
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cst-lightbox-open');
  }

  function initLightbox() {
    document.addEventListener('click', function (event) {
      const open = event.target.closest('[data-cst-lightbox-open]');
      if (open) {
        const gallery = open.closest('[data-cst-gallery]');
        if (gallery) openLightbox(gallery, open.getAttribute('data-cst-lightbox-open'));
        return;
      }

      const close = event.target.closest('[data-cst-lightbox-close]');
      if (close) {
        const lightbox = close.closest('[data-cst-lightbox]');
        if (lightbox) closeLightbox(lightbox);
        return;
      }

      const prev = event.target.closest('[data-cst-lightbox-prev]');
      const next = event.target.closest('[data-cst-lightbox-next]');
      if (prev || next) {
        const lightbox = event.target.closest('[data-cst-lightbox]');
        const gallery = lightbox ? lightbox.closest('[data-cst-gallery]') : null;
        if (!gallery || !lightbox) return;
        const current = Number(lightbox.dataset.cstLightboxIndex || 0);
        renderLightbox(gallery, current + (next ? 1 : -1));
      }
    });

    document.addEventListener('keydown', function (event) {
      const lightbox = document.querySelector('[data-cst-lightbox].is-open');
      if (!lightbox) return;

      const gallery = lightbox.closest('[data-cst-gallery]');
      const current = Number(lightbox.dataset.cstLightboxIndex || 0);

      if (event.key === 'Escape') closeLightbox(lightbox);
      if (event.key === 'ArrowLeft') renderLightbox(gallery, current - 1);
      if (event.key === 'ArrowRight') renderLightbox(gallery, current + 1);
    });
  }

  window.openCstCartDrawer = function () {
    const drawer = document.querySelector('[data-cst-cart-drawer]');
    if (!drawer) return;
    drawer.classList.add('is-open');
    document.body.classList.add('cst-cart-open');
  };

  window.closeCstCartDrawer = function () {
    const drawer = document.querySelector('[data-cst-cart-drawer]');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.classList.remove('cst-cart-open');
  };

  window.refreshCstCartDrawer = async function () {
    const content = document.querySelector('[data-cst-cart-content]');
    const subtotal = document.querySelector('[data-cst-cart-subtotal]');
    if (!content) return;

    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();

      if (subtotal) subtotal.textContent = money(cart.total_price);

      document.querySelectorAll('.cart-count-bubble, [data-cart-count], .cart-count').forEach(function (count) {
        count.textContent = cart.item_count;
      });

      if (!cart.items.length) {
        content.innerHTML = '<p class="cst-cart-empty">Your cart is empty.</p>';
        return;
      }

      content.innerHTML = cart.items.map(function (item) {
        const image = item.image || '';
        const title = item.product_title || item.title || '';
        const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<p>${item.variant_title}</p>` : '';
        const price = money(item.final_line_price);

        return `
          <div class="cst-cart-item">
            ${image ? `<img src="${image}" alt="${title.replace(/"/g, '&quot;')}">` : ''}
            <div>
              <h3>${title}</h3>
              ${variant}
              <p>Qty: ${item.quantity}</p>
              <strong>${price}</strong>
            </div>
          </div>
        `;
      }).join('');
    } catch (error) {
      content.innerHTML = '<p>Could not load cart.</p>';
    }
  };

  function initCartDrawer() {
    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-cst-cart-close]')) {
        window.closeCstCartDrawer();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') window.closeCstCartDrawer();
    });
  }

  async function ajaxAddForm(form, button) {
    const originalText = button ? button.textContent.trim() : '';
    if (button) {
      button.disabled = true;
      button.textContent = 'Adding...';
    }

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { 'Accept': 'application/json' }
      });

      if (!response.ok) throw new Error('Add failed');

      if (button) button.textContent = 'Added ✓';
      await window.refreshCstCartDrawer();
      window.openCstCartDrawer();

      setTimeout(function () {
        if (button) {
          button.disabled = false;
          button.textContent = originalText;
        }
      }, 1800);
    } catch (error) {
      if (button) {
        button.textContent = 'Try again';
        setTimeout(function () {
          button.disabled = false;
          button.textContent = originalText;
        }, 1800);
      }
    }
  }

  function initAjaxProductForms() {
    document.addEventListener('submit', async function (event) {
      const cardForm = event.target.closest('.cst-product-card-v2__form');
      const buyForm = event.target.closest('.cst-buy-box__form');
      const form = cardForm || buyForm;
      if (!form) return;

      const submitter = event.submitter;
      if (submitter && submitter.closest('.shopify-payment-button')) return;
      if (submitter && submitter.classList.contains('shopify-payment-button__button')) return;

      event.preventDefault();
      const button = submitter || form.querySelector('[data-cst-add-button], button[type="submit"]');
      await ajaxAddForm(form, button);
    });
  }

  function initVariantSelectors() {
    document.querySelectorAll('[data-cst-buy-box]').forEach(function (box) {
      const json = box.querySelector('[data-cst-product-json]');
      const form = box.querySelector('.cst-buy-box__form');
      const variantInput = box.querySelector('[data-cst-variant-id]');
      if (!json || !form || !variantInput) return;

      let product;
      try { product = JSON.parse(json.textContent); } catch (error) { return; }

      function updateVariant() {
        const selected = Array.from(form.querySelectorAll('.cst-product-option')).map(function (option) {
          const checked = option.querySelector('input:checked');
          const selectedLabel = option.querySelector('[data-cst-selected-option]');
          if (selectedLabel && checked) selectedLabel.textContent = checked.value;
          return checked ? checked.value : null;
        });

        const variant = product.variants.find(function (item) {
          return item.options.every(function (value, index) { return value === selected[index]; });
        });
        if (!variant) return;

        variantInput.value = variant.id;

        const submit = form.querySelector('[data-cst-add-button]');
        if (submit) {
          submit.disabled = !variant.available;
          submit.textContent = variant.available ? 'Add to cart' : 'Sold out';
        }

        const stock = box.querySelector('[data-cst-stock-text]');
        if (stock) stock.textContent = variant.available ? 'Ready to ship' : 'Sold out';

        const currentPrice = box.querySelector('[data-cst-current-price]');
        const comparePrice = box.querySelector('[data-cst-compare-price]');
        const badge = box.querySelector('[data-cst-sale-badge]');
        if (currentPrice) currentPrice.textContent = money(variant.price);

        const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        if (comparePrice) {
          comparePrice.hidden = !onSale;
          comparePrice.textContent = onSale ? money(variant.compare_at_price) : '';
        }
        if (badge) {
          badge.hidden = !onSale;
          badge.textContent = onSale ? 'Save ' + Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) + '%' : '';
        }

        document.querySelectorAll('[data-cst-mobile-price]').forEach(function (node) {
          node.textContent = money(variant.price);
        });

        if (window.history && window.history.replaceState) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      form.addEventListener('change', updateVariant);
      updateVariant();
    });
  }

  function initMobileAtc() {
    const bar = document.querySelector('[data-cst-mobile-atc]');
    const buyBox = document.querySelector('[data-cst-buy-box]');
    if (!bar || !buyBox) return;

    const button = bar.querySelector('[data-cst-mobile-submit]');
    const form = buyBox.querySelector('.cst-buy-box__form');
    if (button && form) {
      button.addEventListener('click', function () {
        const addButton = form.querySelector('[data-cst-add-button]');
        if (addButton && !addButton.disabled) form.requestSubmit(addButton);
      });
    }

    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0.15 });

    observer.observe(buyBox);
  }

  function initReveal() {
    const items = document.querySelectorAll('.cst-section, .cst-feature-banner, .cst-product-main, .cst-product-card-v2, .cst-card');
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (item) { item.classList.add('is-visible'); });
      return;
    }

    items.forEach(function (item, index) {
      item.classList.add('cst-reveal');
      item.style.setProperty('--cst-reveal-delay', Math.min(index % 6, 5) * 45 + 'ms');
    });

    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });

    items.forEach(function (item) { observer.observe(item); });
  }

  function initPremiumInteractions() {
    document.querySelectorAll('.cst-hero__image-wrap').forEach(function (wrap) {
      wrap.setAttribute('data-cst-parallax', '');
    });

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    document.addEventListener('mousemove', function (event) {
      const hero = document.querySelector('.cst-hero');
      const visual = hero ? hero.querySelector('[data-cst-parallax]') : null;
      if (!hero || !visual) return;

      const rect = hero.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > window.innerHeight) return;

      const x = (event.clientX / window.innerWidth - .5) * 12;
      const y = (event.clientY / window.innerHeight - .5) * 10;
      visual.style.transform = 'translate3d(' + x + 'px,' + y + 'px,0)';
    }, { passive: true });

    document.querySelectorAll('.cst-card, .cst-btn').forEach(function (item) {
      item.classList.add('cst-premium-sheen');
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initHeader();
    initQuantity();
    initGallery();
    initLightbox();
    initCartDrawer();
    initAjaxProductForms();
    initVariantSelectors();
    initMobileAtc();
    initReveal();
    initPremiumInteractions();
  });
})();
